<template>
  <v-menu offset-y>
    <template #activator="{ props }">
      <v-avatar v-bind="props" size="32">
        <v-img :src="avatar" />
      </v-avatar>
    </template>

    <v-list density="compact" class="pt-0" style="min-width: 280px;">
      <!-- User Profile Section -->
      <div class="text-center pa-4">
        <v-avatar size="80" class="mb-3">
          <v-img :src="avatar" />
        </v-avatar>

        <div class="text-h6 font-weight-medium mb-3">{{ userName }}</div>

        <!-- Roles and Department Display - Compact Version -->
        <div class="user-info-compact">
          <!-- Roles -->
          <div v-if="userRoles && userRoles.length > 0" class="info-row">
            <v-icon size="16" color="primary" class="info-icon">mdi-shield-account</v-icon>
            <span class="info-text">{{ userRoles.join(', ') }}</span>
          </div>

          <!-- Department -->
          <div v-if="userDepartments && userDepartments.length > 0" class="info-row">
            <v-icon size="16" color="secondary" class="info-icon">mdi-office-building</v-icon>
            <span class="info-text">{{ userDepartments.join(', ') }}</span>
          </div>
        </div>
      </div>

      <v-divider class="my-2" v-if="$store.state.loginUser.userId != 'concioAdmin'"/>

      <!-- Menu Items -->
      <v-list-item
        v-if="$store.state.loginUser.roles[0].name === 'root'"
        @click="getAccount"
        class="clickable"
      >
        <template #prepend>
          <v-icon icon="mdi-license" />
        </template>
        <v-list-item-title>{{ langKey.labelGetAccount }}</v-list-item-title>
      </v-list-item>

      <v-list-item 
        v-if="$store.state.loginUser.userId != 'concioAdmin'"
        @click="changePassword" class="clickable">
        <template #prepend>
          <v-icon icon="mdi-lock-reset" />
        </template>
        <v-list-item-title>{{ langKey.labelChangePxd }}</v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="$store.state.loginUser.roles[0].name === 'root'"
        @click="watermarkSetting"
        class="clickable"
      >
        <template #prepend>
          <v-icon icon="mdi-watermark" />
        </template>
        <v-list-item-title>{{ langKey.labelWatermarkSetting }}</v-list-item-title>
      </v-list-item>

      <v-divider class="my-2" />

      <v-list-item @click="logOut" class="fw-semibold clickable">

        <template #prepend>
          <v-icon icon="mdi-logout" />
        </template>
        <v-list-item-title>{{ langKey.labelLogout }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import avatar from "@/assets/images/icon_default_headpic.png"
import imanager3Appframe from "@/scripts/imanager3-appframe"
import iStoreUtils from "@/scripts/istore-utils.js"

export default {
  name: 'AppHeaderDropdownAccount',
  emits: ['logout'],
  data() {
    return {
      avatar: avatar,
      changeCidHovered: false,
      dropdownMenuStyle: {
        top: '0',
        left: '0',
      },
      topOffset: '',
      rightOffset: '',
    }
  },
  methods: {
    logOut() {
      this.$emit('logout', this.langKey.confirmLogout)
    },
    pluginManager() {
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "PluginManager"
        }
      )
      this.$store.commit('setCurrentMenu')
      this.$router.push('/pluginManager')
    },
    getAccount() {
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "GetAccount"
        }
      )
      this.$store.commit('setCurrentMenu')
      this.$router.push('/getAccount')
    },
    changePassword() {
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "ChangePassword"
        }
      )
      this.$store.commit('setCurrentMenu')
      this.$router.push('/changePassword')
    },
    watermarkSetting() {
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "WatermarkSetting"
        }
      )
      this.$store.commit('setCurrentMenu')
      this.$router.push('/watermarkSetting')
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  },
  computed: {
    userName() {

      let name = this.$store.state.loginUser.starNumber;

      if (name && name == this.$store.state.loginUser.userId) {
        name = this.$store.state.loginUser.userName;
      }
      if (!name) {
        name = this.$store.state.loginUser.nickName
      }
      if (!name) {
        name = this.$store.state.loginUser.userName
      }
      if (!name) {
        name = this.$store.state.loginUser.userId
      }

      return name;
    },
    userRoles() {
      // Get roles from the loginUser state
      const roles = this.$store.state.loginUser.roles || [];

      // Check if roles are objects with uuid and name (new format)
      // or just strings (old format for backward compatibility)
      const roleNames = roles.map(role => {
        if (typeof role === 'object' && role.name) {
          return role.name;
        }
        return role; // Old format: just a string
      });

      // Return role names, limiting to first 3 to avoid overflow
      return roleNames.slice(0, 3);
    },
    userDepartments() {
      // Get departments from the loginUser state
      const departments = this.$store.state.loginUser.department || [];

      // Check if departments are objects with uuid and name (new format)
      // or just strings (old format for backward compatibility)
      const departmentNames = departments.map(dept => {
        if (typeof dept === 'object' && dept.name) {
          return dept.name;
        }
        return dept; // Old format: just a string
      });

      // Return department names, limiting to first 3 to avoid overflow
      return departmentNames.slice(0, 3);
    },
  },
}
</script>

<style scoped>
.dropdown-menu-left {
  position: absolute;
}

.gap-1 {
  gap: 4px;
}

.text-grey {
  color: #666;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Compact user info styles */
.user-info-compact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 13px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.info-icon {
  flex-shrink: 0;
}

.info-text {
  color: #424242;
  font-weight: 500;
  text-align: center;
}
</style>
